/**
 * What is missing from the trip, in the words the booking buttons use
 * (CarListingDetailPage handleBooking), or null when it can be booked. The
 * phone booking asks it before "Book this car" opens the steps (1NOW-11155).
 */
export const tripError = (t: {
  pickupLocation: any;
  sameDropoffLocation: boolean;
  dropOffLocation: any;
  startDate: Date | null;
  endDate: Date | null;
  startTime?: string | null;
  endTime?: string | null;
}): string | null => {
  if (t.pickupLocation === null) return "Please select pick-up location";
  if (!t.sameDropoffLocation && t.dropOffLocation === null) return "Please select drop-off location";
  if (t.startDate === null) return "Start date is not set";
  if (t.endDate === null) return "End date is not set";
  if (!t.startTime) return "Start time is not set";
  if (!t.endTime) return "End time is not set";
  return null;
};
